const page = "result-information";
const pastExpComponent = "pastExperienceCard";
const eatingHabitsComponent = "eatingHabitsCard";

export const pastExperience = {
  caption: `${page}.${pastExpComponent}.caption`,
  header: `${page}.${pastExpComponent}.header`,
  list: {
    header: `${page}.${pastExpComponent}.list.header`,
    items: [
      `${page}.${pastExpComponent}.list.items.1`,
      `${page}.${pastExpComponent}.list.items.0`,
      `${page}.${pastExpComponent}.list.items.2`,
    ],
  },
};

export const eatingHabits = {
  caption: `${page}.${eatingHabitsComponent}.caption`,
  header: `${page}.${eatingHabitsComponent}.header`,
  list: {
    header: `${page}.${eatingHabitsComponent}.list.header`,
    items: [
      `${page}.${eatingHabitsComponent}.list.items.1`,
      `${page}.${eatingHabitsComponent}.list.items.0`,
      `${page}.${eatingHabitsComponent}.list.items.2`,
    ],
  },
};
